import { createFileRoute } from '@tanstack/react-router'
import { DocumentDetailPage } from '../../../components/DocumentDetailPage'

export const Route = createFileRoute('/$org/documents/$docUid')({
    component: DocumentDetail,
})

function DocumentDetail() {
    return <DocumentDetailPage />
} 